import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, ArrowRight, ShoppingBag } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

const CheckoutCancelPage = () => {
  return (
    <div className="App bg-black text-white min-h-screen">
      <Navbar />
      <section className="pt-32 md:pt-40 pb-24 min-h-[80vh]">
        <div className="max-w-[900px] mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            data-testid="checkout-cancelled"
            className="border border-neutral-900 bg-[#0a0a0a] p-8 md:p-12"
          >
            <div className="text-[10px] uppercase tracking-[0.4em] text-amber-400 mb-5">
              — AfroAm Store · Checkout
            </div>
            <XCircle size={42} className="text-neutral-400 mb-6" />
            <h1 className="font-display uppercase text-4xl md:text-6xl text-white leading-[0.9]">
              Checkout
              <br />
              <span className="text-amber-400">cancelled.</span>
            </h1>
            <p className="text-neutral-300 mt-6 max-w-2xl leading-relaxed">
              Your cart is saved. Pick up where you left off whenever you're ready.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link
                to="/store"
                data-testid="cancel-back-store"
                className="inline-flex items-center gap-2 bg-amber-400 text-black px-6 py-3.5 text-xs uppercase tracking-[0.28em] font-bold hover:bg-amber-300 transition-colors"
              >
                <ShoppingBag size={14} /> Back to Store
              </Link>
              <Link
                to="/"
                className="inline-flex items-center gap-2 border border-white text-white px-6 py-3.5 text-xs uppercase tracking-[0.28em] font-bold hover:bg-white hover:text-black transition-colors"
              >
                Home <ArrowRight size={14} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default CheckoutCancelPage;
